import projects from "./projects/projectsData";

export const SITE_URL = "https://avida2c.me";
export const SITE_NAME = "Avida2C";
export const SITE_LOCALE = "en_US";
export const SITE_AUTHOR = "Nadine (Avida2C)";
export const PERSON_ID = `${SITE_URL}/#person`;
export const WEBSITE_ID = `${SITE_URL}/#website`;

export const WHAT_I_DO_LEAD = "From research to reality,";
export const WHAT_I_DO_FOLLOW =
  "I connect user needs, market insights, and information architecture to responsive React and Next.js products. I design in Figma, build with reusable components, and focus on clean, high-fidelity UI.";
export const WHAT_I_DO = `${WHAT_I_DO_LEAD} ${WHAT_I_DO_FOLLOW}`;

export const DEFAULT_OG_IMAGE = `${SITE_URL}/images/Avida2C.png`;
export const DEFAULT_OG_IMAGE_ALT =
  "Avida2C portfolio";
export const DEFAULT_OG_IMAGE_WIDTH = 512;
export const DEFAULT_OG_IMAGE_HEIGHT = 512;

export const PROJECT_THUMBNAIL_WIDTH = 700;
export const PROJECT_THUMBNAIL_HEIGHT = 525;

const formatProjectPageDescription = (summary) => {
  const firstParagraph = (summary ?? "").split(/\n\n+/).filter(Boolean)[0] ?? "";
  return `Case study: ${firstParagraph}`;
};

export const PROJECT_PAGE_DESCRIPTIONS = Object.fromEntries(
  projects.map(({ link, summary }) => [
    link,
    formatProjectPageDescription(summary),
  ]),
);

export const PAGE_DESCRIPTIONS = {
  "/":
    `${SITE_AUTHOR} — ${WHAT_I_DO}`,
  "/projects":
    "Browse Nadine's portfolio — UI/UX case studies, React apps, e-commerce, and creative design projects by Avida2C.",
  "/portfolio-pdf":
    "A print-friendly Avida2C portfolio PDF deck covering research, design, and React/Next.js build case studies.",
  "/about":
    `Meet ${SITE_AUTHOR}. ${WHAT_I_DO}`,
  "/contact":
    "Get in touch with Avida2C for freelance design-dev work, collaborations, and project inquiries. Contact form and FAQs inside.",
  "/terms":
    "Terms of Service for the Avida2C portfolio website, covering usage rights, intellectual property, and liability.",
  "/privacy":
    "Privacy Policy for Avida2C — how personal data is collected through the contact form, cookies, and standard hosting logs.",
  ...PROJECT_PAGE_DESCRIPTIONS,
};

export const getProjectByPath = (pathname) =>
  projects.find((project) => project.link === pathname);

export const getProjectImageUrl = (pathname) => {
  const project = getProjectByPath(pathname);
  return project ? `${SITE_URL}/${project.imgSrc}` : null;
};

export const PROJECT_OG_IMAGES = Object.fromEntries(
  projects.map(({ link, imgSrc }) => [link, `${SITE_URL}/${imgSrc}`]),
);
